var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{fill:#435877;stroke:#fff;stroke-width:0.2px;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144 -596)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(144 596)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 36.5,
    cy: 36.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 36.5,
    cy: 36.5,
    r: 36
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(164 617)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M28.483,8.22H26.81L22.591,4H11.168L6.948,8.22H5.275A5.277,5.277,0,0,0,0,13.494V26.154a5.277,5.277,0,0,0,5.275,5.275H28.483a5.277,5.277,0,0,0,5.275-5.275V13.494A5.277,5.277,0,0,0,28.483,8.22Zm3.165,17.934a3.174,3.174,0,0,1-3.165,3.165H5.275A3.174,3.174,0,0,1,2.11,26.154V20.879H8.717a8.427,8.427,0,0,0,16.324,0h6.607Zm-21.1-7.385a6.33,6.33,0,1,1,6.33,6.33A6.336,6.336,0,0,1,10.549,18.769Zm21.1,0h-6.33a8.44,8.44,0,1,0-16.879,0H2.11V13.494A3.174,3.174,0,0,1,5.275,10.33H7.821l4.22-4.22h9.676l4.22,4.22h2.547a3.174,3.174,0,0,1,3.165,3.165Z",
    transform: "translate(0 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.6648875e5ab77c7fd55fa90f09db794a.svg";
export { ForwardRef as ReactComponent };